// extracted by mini-css-extract-plugin
module.exports = {"link_text":"animateLinkText_link_text__lbmMt","text_wrapper":"animateLinkText_text_wrapper__UW5qR","hide":"animateLinkText_hide__zOzXR"};